<template>
  <div class="flex items-center justify-center w-full clamp-gap-4-8">
    <AIconButton
      icon="arrow-left"
      size="sm"
      ariaLabel="Go to previous page"
      :disabled="currentPage === 1"
      class="shrink-0"
      @click="goToPage(currentPage - 1)"
    />
    <div class="flex clamp-gap-3-8 items-end text-body-sm tp:text-body-md">
      <button v-if="showFirstPage" @click="goToPage(firstPage)">
        {{ firstPage }}
      </button>
      <span v-if="showEllipsisBefore">...</span>
      <button
        v-for="number in visiblePageNumbers"
        :key="number"
        :disabled="currentPage === number"
        class="text-body-sm tp:text-body-md"
        :class="{
          'font-bold underline': currentPage === number,
        }"
        @click="goToPage(number)"
      >
        {{ number }}
      </button>
      <span v-if="showEllipsisAfter">...</span>
      <button v-if="showLastPageLink" @click="goToPage(totalPages)">
        {{ totalPages }}
      </button>
    </div>

    <AIconButton
      icon="arrow-right"
      size="sm"
      ariaLabel="Go to next page"
      :disabled="currentPage === totalPages"
      class="shrink-0"
      @click="goToPage(currentPage + 1)"
    />
  </div>
</template>

<script setup lang="ts">
import usePagination from '@/composables/usePagination';

const props = defineProps<{
  postsPerPage: number;
  totalItems: number;
}>();
const emits = defineEmits();
const router = useRouter();

const {
  currentPage,
  totalPages,
  goToPage,
  showFirstPage,
  showLastPageLink,
  showEllipsisAfter,
  showEllipsisBefore,
  firstPage,
  visiblePageNumbers,
} = usePagination({
  postsPerPage: props.postsPerPage,
  totalItems: computed(() => props.totalItems),
  router: router,
  emit: emits,
  pageQueryName: 'page',
});
</script>
